import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/homepage/hero-section/hero-skeleton-loader.tsx");
